import type { User } from '@/store/modules/auth';
import { hasPermission } from '@/support/permissions';

interface LandingCandidate {
  name: string;
  permission: string;
}

const CASHIER_CANDIDATES: LandingCandidate[] = [
  { name: 'CashierSales', permission: 'sales.create' },
  { name: 'CashierInventories', permission: 'inventories.count' },
  { name: 'CashierEndOfDay', permission: 'cash_counts.create' },
  { name: 'Expenses', permission: 'expenses.view' },
];

const ADMIN_CANDIDATES: LandingCandidate[] = [
  { name: 'Dashboard', permission: 'dashboard.view' },
  { name: 'Sites', permission: 'shops.view' },
  { name: 'Products', permission: 'products.view' },
  { name: 'Purchases', permission: 'purchases.view' },
  { name: 'Expenses', permission: 'expenses.view' },
  { name: 'Sales', permission: 'sales.view' },
  { name: 'Clients', permission: 'clients.view' },
  { name: 'Inventories', permission: 'inventories.view' },
  { name: 'Users', permission: 'users.view' },
  { name: 'SettingsGeneral', permission: 'settings.view' },
  { name: 'ExpenseTypes', permission: 'expenses.manage_types' },
];

export function authenticatedLandingRoute(
  user: User | null | undefined,
  moduleEnabled: (module: string) => boolean
): string {
  const role = String(user?.role || '');
  const candidates = role === 'caissier' ? CASHIER_CANDIDATES : ADMIN_CANDIDATES;
  const accessible = candidates.find(({ permission }) => {
    const module = permission.split('.', 1)[0];
    return hasPermission(user, permission) && moduleEnabled(module);
  });

  return accessible?.name || (role === 'caissier' ? 'CashierSales' : 'Dashboard');
}
